export const promptSuggestions = [
  'How many time offs did the team take last 3 months?',
  'How many sick days are taken on average per month?',
  'How many bills are created on an average day?',
  'What is the average monthly amount for purchase orders?',
  'How many vendors were approved last month?',
  'What is the average bill amount during the last 3 months?',
]
